import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  currentUser,
  fetchNetWorth,
  loginUser,
  generateToken,
  verifyGoogleAuthOTP,
  setUser,
    saveCookieConsent,
} from "../services/user-service";
import { faEye, faEyeSlash, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useEffect } from "react";
import GoogleAuthPopup from "./GoogleAuthPopup";
import "./LoginPage.css";
import { toast } from "react-toastify";
import { trackLogin } from "../utils/analytics";

const Login = ({ onBack }) => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [loginDetail, setLoginDetail] = useState({
    username: "",
    password: ""
  });

  const handleChanges = (event, property) => {
    setLoginDetail({ ...loginDetail, [property]: event.target.value });
  };

  const [visible, setVisible] = useState(false);
  const [showGoogleAuthPopup, setShowGoogleAuthPopup] = useState(false);
  const [tempToken, setTempToken] = useState(null); // Store temporary token for OTP verification
  const [showPassword, setShowPassword] = useState(false);
  const [otpError, setOtpError] = useState(""); // State to store OTP error
  const [passwordExpired, setPasswordExpired] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

    const syncCookieConsent = async () => {

        const consentType =
            localStorage.getItem("cookieConsent");

        const consentVersion =
            localStorage.getItem("cookieConsentVersion");

        if (!consentType || !consentVersion) {
            return;
        }

        try {

            await saveCookieConsent(
                consentType,
                consentVersion
            );

            console.log(
                "Cookie consent synced to backend"
            );

        } catch (error) {

            console.error(
                "Failed to sync cookie consent",
                error
            );
        }
    };

  
  const loginFormSubmit = (event) => {
    event.preventDefault();
    
  
    const { username, password } = loginDetail;

  if (username.trim() === "" || password.trim() === "") {
    toast.warning("Please enter both username and password");
    return; 
  }
  
    generateToken(loginDetail)
    .then((response) => {
   
      if (response.data && response.data.token) {
        
        loginUser(response.data.token);
          syncCookieConsent();
        const token = "Bearer " + response.data.token;
        
        currentUser(token).then((response) => {
          const user = response.data;
          setUser(user);
          login();
            trackLogin();
    

          if (user.role === "USER") {
            navigate("/user/dashboard");
          } else if (user.role === "ATTORNEY") {
            navigate("/attorney/dashboard");
          } else if (
            user.role === "BENEFICIARY" &&
            user.firstlevelapproval === "true"
          ) {
            navigate("/beneficiary/dashboard");
          } else if (user.role === "ADMIN") {
            navigate("/admin/dashboard");
          } else if (user.role === "TENANT_ADMIN"|| user.role === "TENANT_USER") {
             navigate("/organization/dashboard");
           }else if (user.role === "ORG_USER") {
               navigate("/user/dashboard");
           }else {
            navigate("/dashboard"); 
          }
        });
      } else if (response.data && response.data.otpRequired) {
         setShowGoogleAuthPopup(true);
      } else {
        toast.error("Invalid username or password!");
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        toast.error("Invalid username or password!");
      } else if (error.response && error.response.status === 403) {
        toast.warning("Your password has expired. Please reset it.");
        navigate("/forgot");
      } else {
        toast.error("Something went wrong. Try again later.");
      }
    });
};
  
const [, forceRender] = useState(0);
useEffect(() => {
  if (showGoogleAuthPopup) {
    forceRender((prev) => prev + 1);  
  }
}, [showGoogleAuthPopup]);

   const handleOtpSuccess = (otp) => {
     verifyGoogleAuthOTP({ username: loginDetail.username, otp })
      .then((jwtTokenData) => {
        const token = "Bearer " + jwtTokenData?.data?.token;
        loginUser(jwtTokenData?.data?.token);
          syncCookieConsent();

        currentUser(token).then((response) => {
          const user = response.data;
          setUser(user);
          login();
  
          if (user.role !== "ATTORNEY" && user.role !== "TENANT_ADMIN" && user.role !== "TENANT_USER") {
            if (user.commonId) {
              fetchNetWorth(user.commonId);
            }
            else {
              console.warn("User does not have commonId:", user);
            }
          }
          

          if (user.role === "USER") {
            navigate("/user/dashboard");
          } else if (user.role === "ATTORNEY") {
            navigate("/attorney/dashboard");
          } else if (
            user.role === "BENEFICIARY" &&
            user.firstlevelapproval === "true"
          ) {
            navigate("/beneficiary/dashboard");
          } else if (user.role === "TENANT_ADMIN") {
             navigate("/organization/dashboard");
           }else if (user.role === "ORG_USER") {
                navigate("/user/dashboard");
            }else if (user.role === "ADMIN") {
            navigate("/admin/dashboard");
          }
        });
      })
      .catch(() => {
        toast.error("Invalid OTP. Please try again.");  
        
         setShowGoogleAuthPopup(false);
        setTimeout(() => {
          setShowGoogleAuthPopup(true);
        }, 0);
      });
  };
  

  return (
    <div className="login-popup">
      <div className="loginpage_login">
      <form className="form" onSubmit={loginFormSubmit}>
          <div className="login_heading">
            <p>Login</p>
            <div className="login_cancel_icon">
              <FontAwesomeIcon
                className="cancel_icon_login"
                icon={faTimes}
                onClick={onBack}
              />
            </div>
          </div>

          <div className="flex-column">
            <label>Username</label>
          </div>
          <div className="inputForm">
            <input
              type="text"
              className="input"
              // placeholder="Enter your username"
              placeholder="Enter username or email"
              id="username"
              value={loginDetail.username || ""}
              onChange={(e) => handleChanges(e, "username")}
              onBlur={(e) => {
                const lowerUsername = e.target.value.toLowerCase();
                setLoginDetail((prev) => ({
                  ...prev,
                  username: lowerUsername,
                }));
              }}
            />
          </div>
          <div className="flex-column">
            <label>Password</label>
          </div>
          <div className="inputForm">
            <input
              className="input"
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              id="password"
              onChange={(e) => handleChanges(e, "password")}
            />
          </div>

          <div className="flex-row login_page_btns">
            <div className="show_password_btn">
              <input
                type="checkbox"
                style={{ marginRight: "10px" }}
                onClick={handleTogglePassword}
              />
              <label>Show Password</label>
            </div>
            <div>
              <span className="span">
                <Link className="span" to="/forgot">
                  Forgot password?
                </Link>
              </span>
            </div>
          </div>

          <button className="button_submit_login">Sign In</button>
        </form>
      </div>

     {/* Google Authenticator OTP Popup */}
      {showGoogleAuthPopup ? (
        <>
          <p>Popup should appear here</p> {/* Debugging message */}
          <GoogleAuthPopup
            onOtpSubmit={handleOtpSuccess}
            onClose={() => setShowGoogleAuthPopup(false)}
            otpError={otpError} // Pass error message
          />
        </>
      ) : null}
    </div>
  );
};

export default Login;
